module.exports = __webpack_public_path__ + "static/08-cc654dcb7b405dd7c7c7cbb1176e1328.jpg";